<template>
  <div class="equipment">
    <PageTopNav :tabsShow3="true" @changeTab3="changeTab3" :tabList3="tabList3" isAi isAi2 :changeIndex3="changeIndex3" />
    <router-view></router-view>
    <MyNav />
  </div>
</template>

<script>
import { mapMutations } from 'vuex'
// getEquipmentGroupApi
// import { getDeviceListApi } from '@/request/api'

export default {
  components: {
    MyNav: () => import('@/components/MyNav.vue'),
    PageTopNav: () => import('@/components/PageTopNav.vue')
  },
  data() {
    return {
      tabList3: [
        { deviceType: '设备状态预警', name: '设备状态预警' },
        { deviceType: '苗情分析', name: '苗情分析' },
        { deviceType: '4', name: '气象采集' },
        { deviceType: '8', name: '水质检测' },
        { deviceType: '3', name: '土壤检测' },
        { deviceType: '2', name: '虫情监测' },
        { deviceType: '6', name: '智能灌溉' }
      ],
      changeIndex3: 999
    }
  },
  // created() {
  //   this.getEquipmentGroup(this.$route.query.id)
  // },

  methods: {
    ...mapMutations('user', ['SET_EQUIPMENT_Name']),
    deepMergeFun(obj1, obj2) {
      let _this = this
      for (let key in obj2) {
        obj1[key] = obj1[key] && obj1[key].toString() === '[object Object]' ? _this.deepMerge(obj1[key], obj2[key]) : (obj1[key] = obj2[key])
      }
      return obj1
    },
    // async getEquipmentGroup(id) {
    //   const { code, data } = await getEquipmentGroupApi();
    //   if (code === 200) {
    //     this.tabList3 = data;
    //     if (!sessionStorage.getItem("equipmentName")) {
    //       sessionStorage.setItem("equipmentId", data[0].id);
    //       sessionStorage.setItem("equipmentName", data[0].icon);
    //     }
    //     this.changeIndex3 = this.$route.query.id || 999;
    //     for (const key in this.tabList3) {
    //       if (Object.hasOwnProperty.call(this.tabList3, key)) {
    //         if (this.tabList3[key].icon === "video") {
    //           this.tabList3[key].name = "苗情分析";
    //         } else if (this.tabList3[key].icon === "gate") {
    //           this.tabList3[key].name = "智能灌溉";
    //         } else if (this.tabList3[key].icon === "heat") {
    //           delete this.tabList3[key];
    //         }
    //       }
    //     }
    //   }
    //   if (!id) {
    //     this.changeTab3({ id: "", icon: "" });
    //   }
    // },
    // async getEquipmentGroup(id) {
    //   const { code, data } = await getDeviceListApi()
    //   if (code === 200) {
    //     // this.tabList3 = data
    //     if (!sessionStorage.getItem('equipmentName')) {
    //       sessionStorage.setItem('equipmentId', data[0].id)
    //       sessionStorage.setItem('equipmentName', data[0].icon)
    //     }
    //     this.changeIndex3 = this.$route.query.id || 999
    //     // for (const key in this.tabList3) {
    //     //   if (Object.hasOwnProperty.call(this.tabList3, key)) {
    //     //     if (this.tabList3[key].icon === 'video') {
    //     //       this.tabList3[key].name = '苗情分析'
    //     //     } else if (this.tabList3[key].icon === 'gate') {
    //     //       this.tabList3[key].name = '智能灌溉'
    //     //     } else if (this.tabList3[key].icon === 'heat') {
    //     //       delete this.tabList3[key]
    //     //     }
    //     //   }
    //     // }
    //   }
    //   if (!id) {
    //     // this.changeTab3({ id: '', icon: '' })
    //   }
    // },
    // { id, icon }
    changeTab3({ id }) {
      console.log('item', id)

      if (id) {
        this.changeIndex3 = id
      }
      sessionStorage.setItem('childTitle3', this.changeIndex3)

      switch (id) {
        case '设备状态预警':
          sessionStorage.setItem('equipmentName', '设备状态预警')
          this.SET_EQUIPMENT_Name({ icon: '设备状态预警' })
          this.$router.push({
            name: 'statusWarning'
          })
          break
        case '4':
          sessionStorage.setItem('equipmentName', '')
          this.SET_EQUIPMENT_Name({ icon: '' })

          this.$router.push({
            name: 'meteorological',
            query: { id }
          })
          break

        case 'video':
          sessionStorage.setItem('equipmentName', '')
          this.SET_EQUIPMENT_Name({ icon: '' })

          this.$router.push({
            name: 'gather',
            query: { id }
          })
          break
        case '8':
          sessionStorage.setItem('equipmentName', 'water')
          this.SET_EQUIPMENT_Name({ icon: 'water' })

          this.$router.push({
            name: 'chemical',
            query: { id }
          })
          break
        case '3':
          this.SET_EQUIPMENT_Name({ icon: 'soil' })
          sessionStorage.setItem('equipmentName', 'soil')
          this.$router.push({
            name: 'chemical',
            query: { id }
          })
          break
        case '2':
          this.SET_EQUIPMENT_Name({ icon: 'insect' })
          sessionStorage.setItem('equipmentName', 'insect')
          this.$router.push({
            name: 'chemical',
            query: { id }
          })
          break
        case '苗情分析':
          this.SET_EQUIPMENT_Name({ icon: 'grow' })
          sessionStorage.setItem('equipmentName', 'grow')
          this.$router.push({
            name: 'chemical',
            query: { id:678 }
          })
          break
        case '6':
          this.SET_EQUIPMENT_Name({ icon: 'gate' })
          sessionStorage.setItem('equipmentName', 'gate')
          this.$router.push({
            name: 'chemical',
            query: { id }
          })
          break
        case '':
          this.SET_EQUIPMENT_Name({ icon: '' })
          sessionStorage.setItem('equipmentName', '')
          this.$router.push({
            name: 'equipmentAi'
          })
          break
      }
    }
  }
}
</script>
<style lang="less" scoped>
.equipment {
  width: 100%;
  min-height: 100vh;
  background-color: #071a2c;
  padding: 62px 0 0;
  color: #fff;
  overflow: hidden;
}
</style>
